import React, { useEffect } from 'react';
import { Navigate } from 'react-router';
import { authClient } from '../../../lib/auth-client';

const Logout = () => {
    useEffect(() => {
        authClient.signOut();
    }, []);

    return <Navigate to="/login" />;
};

export default Logout;
